@if(finraExceptionRow){
<!-- Exception Details -->
<span>
  <mat-list-item class="cais-list-item-title">Exception Details</mat-list-item>
  <div class="ui-grid-col-12 container">
    @for(viewRow of ExceptionCodeDetailsCols; track viewRow.field_Name + '-'+ $index; let i = $index){
    <span
      [ngClass]="(viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4')">
      <span>
        <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
          <div
            [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
            <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
          </div>
          <div
            [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
            <span>
              <input [disabled]="true" pInputText [(ngModel)]="finraExceptionRow[viewRow.field_Name]"
                [title]="finraExceptionRow[viewRow.field_Name]" />
            </span>
          </div>
        </div>
      </span>
    </span>
  }
  </div>
  <mat-divider></mat-divider>
</span>
}